import { render, staticRenderFns } from "./add-kompetensi.vue?vue&type=template&id=d6263bba&"
import script from "./add-kompetensi.vue?vue&type=script&lang=js&"
export * from "./add-kompetensi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports